import type { BasedFunctionConfig } from '@based/sdk/functions'

export default {
  type: 'query',
  name: 'list-conversations',
  public: false,
} as BasedFunctionConfig
